import { makeStyles } from "@material-ui/core";

export const PricingByClientStyle = makeStyles((theme) => ({
    card: {
        margin: '1rem 0',
        padding: '2rem ',
        paddingBottom: '5rem',
        height: '100%'
    },
    activityCell: {
        fontWeight: 500
    },
    activityRow: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    activityIcon: {
        color: theme.palette.text.secondary,
        fontSize: '1.25rem',
        marginLeft: 'auto'
    },
    emptyCell: {
        textAlign: 'center'
    },
    pmfChip: {
        backgroundColor: '#2196f3',
        color: 'white',
        height: '16px',
        fontSize: '0.5rem',
    },
    emptyStateMessage: {
        textAlign: 'center',
        padding: '3rem',
        color: '#666',
        fontSize: '1rem'
    },
    // Legend styles
    legendPaper: {
        padding: '12px 16px',
        marginBottom: '16px'
    },
    legendChip: {
        backgroundColor: '#2196f3',
        color: 'white',
        marginRight: '4px'
    },
    legendBox: {
        width: '16px',
        height: '16px',
        marginRight: '6px'
    },
    legendVarianceBox: {
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107'
    },
    legendLowMarginBox: {
        backgroundColor: '#ffebee',
        border: '1px solid #f44336'
    },
    legendNotConfiguredBox: {
        backgroundColor: '#f5f5f5',
        border: '1px solid #e0e0e0'
    },
    legendNotConfiguredText: {
        color: '#9e9e9e'
    },
    cellIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '6px'
    },
    cell: {
        cursor: 'pointer',
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        height: "100%",
        transition: "opacity 0.15s ease, transform 0.15s ease",
        "&:hover": {
            opacity: 0.8,
            transform: "translateY(-1px)",
        },
    },
    alert: {
        marginBottom: '1rem',
        border: `1px solid ${theme.palette.warning.main}`,
        borderRadius: '6px',
        fontWeight: 500,
        '& .MuiAlert-icon': {
            color: theme.palette.warning.dark,
        },
    }
}));